module.exports = __webpack_public_path__ + "static/media/02-08.1f81ebff.png";